import { getEnvVar } from 'utils/env'

// The dev CDN doesn't serve the ratings routes yet, so only production reads them from the CDN.
export function isRatingsCDNEnabled() {
  return getEnvVar('APP_ENV') === 'production'
}
